export const BLOCK_STATSIG_REQUESTS_KEY = 'block-statsig-requests';
/**
 * Built-in Statsig localstorage key that tracks when each, cached Statsig
 * evaluation was last modified.
 */
export const STATSIG_LAST_MODIFIED_CACHE_KEY = 'statsig.last_modified_time.evaluations';

export const TARGETED_APP_STATSIG_CLIENT_KEY = 'client-qdnrRmOx8vBXfbCNUbN32i157czmxIwupDOXVsYe7ny';
export const STATSIG_STALE_CACHE_CLEARED_AT_KEY = 'statsig.stale_cache_date';
